import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from './dbSelector';

const selectSectorsInHall = createSelector(
    orm,
    dbSelector,
    (session) => {
        const hall = session.Hall.all().first();
        if (hall && hall.sectors) {
            try {
                return hall.sectors.toModelArray();
            } catch (e) {
                return [];
            }
        }
        return [];
    },
);

export default selectSectorsInHall;
